import BookingCollectionDialog from './BookingCollectionDialog';

export default BookingCollectionDialog;
